import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ATCAirTrafficControlTowerIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M18 22H7V17H18V22ZM12.5 2C13.3284 2 14 2.67157 14 3.5C14 4.15281 13.5822 4.70597 13 4.91211V6H19V7H22V9H21.7676L20.4277 14H20.5V16H4.5V14H4.5459L3.20605 9H3V7H6V6H12V4.91211C11.4178 4.70597 11 4.15281 11 3.5C11 2.67157 11.6716 2 12.5 2ZM5.58105 14H8.83887L8.13672 9H4.24121L5.58105 14ZM9.84863 14H15.1504L15.8535 9H9.14648L9.84863 14ZM16.1611 14H19.3926L20.7324 9H16.8633L16.1611 14Z'
                fill='currentColor'
            />
        </>
    ),
})

ATCAirTrafficControlTowerIcon.displayName = 'ATCAirTrafficControlTowerIcon'
